<template>
    <div class="customer-submenu" ref="container">
        <a
            v-for="(item, index) in resolvedItems"
            :key="item.label"
            :href="item.url"
            class="submenu-item"
            :class="{ 'submenu-item--active': item.active }"
            :ref="item.active ? 'activeItem' : null"
        >
            <component
                v-if="item.icon"
                :is="'aut-icon-' + item.icon"
                class="submenu-item__icon"
            ></component>
            <span class="submenu-item__label">{{ item.label }}</span>
        </a>
    </div>
</template>

<script>
export default {
    name: 'SubMenu',

    props: {
        items: {
            type: Array,
            required: true,
            default: () => [
                { label: 'Mijn Autohopper', url: '/dashboard', active: true, icon: 'car' },
                { label: 'Reserveringen', url: '/dashboard/reservations', active: false, icon: 'reservations' },
                { label: 'Accountgegevens', url: '/dashboard/account', active: false, icon: 'account' },
                { label: 'Uitloggen', url: '/user/logout', active: false, icon: 'logout' }
            ]
        }
    },

    computed: {
        logoutUrl() {
            return (typeof drupalSettings !== 'undefined' && drupalSettings.logoutUrl)
                ? drupalSettings.logoutUrl
                : '/user/logout';
        },

        resolvedItems() {
            return this.items.map(item =>
                item.icon === 'logout' ? { ...item, url: this.logoutUrl } : item
            );
        },
    },

    watch: {
        items: {
            handler() {
                this.$nextTick(() => {
                    this.scrollToActive();
                });
            },
            deep: true
        }
    },

    mounted() {
        this.$nextTick(() => {
            this.scrollToActive();
        });
    },

    methods: {
        scrollToActive() {
            const container = this.$refs.container;
            const activeItem = this.$refs.activeItem ? this.$refs.activeItem[0] : null;

            if (container && activeItem && window.innerWidth < 768) {
                const containerWidth = container.offsetWidth;
                const itemWidth = activeItem.offsetWidth;
                const itemLeft = activeItem.offsetLeft;

                // Alleen centreren als het niet het eerste item is
                if (itemLeft === 0) {
                    container.scrollTo({
                        left: 0,
                        behavior: 'smooth'
                    });
                    return;
                }

                const scrollLeft = itemLeft - (containerWidth / 2) + (itemWidth / 2);

                container.scrollTo({
                    left: scrollLeft,
                    behavior: 'smooth'
                });
            }
        }
    },
}
</script>

<style scoped>
.customer-submenu {
    display: flex;
    flex-direction: row;
    gap: 8px;
    width: 100%;
    overflow-x: auto;
    padding-bottom: 1rem;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none; /* Firefox */
}

.customer-submenu::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
}

@media (min-width: 768px) {
    .customer-submenu {
        flex-direction: column;
        gap: 4px;
        max-width: 262px;
        overflow-x: visible;
        padding-bottom: 0;
    }
}

.submenu-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    background: #ffffff;
    border: 1px solid #cdd6d7;
    border-radius: 5px;
    color: #000000;
    font-family: 'Open Sans', sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-decoration: none;
    transition: border-color 0.15s ease, color 0.15s ease;
    white-space: nowrap;
}

@media (min-width: 768px) {
    .submenu-item {
        padding: 16px 24px;
    }
}

.submenu-item:hover {
    border-color: #ed702a;
    color: #ed702a;
    text-decoration: none;
}

.submenu-item--active {
    border-color: #ed702a;
    color: #ed702a;
}

.submenu-item__icon {
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.submenu-item__icon svg path {
    fill: currentColor;
}

.submenu-item__label {
    white-space: nowrap;
}
</style>
